import { render } from "./games.page.vue?vue&type=template&id=0638d3d8"
import script from "./games.page.vue?vue&type=script&lang=js"
export * from "./games.page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__